import React from 'react';
import CommonCard from "./common_card";
import { TypographyBold } from "../style/typography";
import { BoxCenterStart } from "../style/box";
import { BaseDialog } from "./base_dialog";

// stylesは必要に応じてpropsで渡すか、このファイル内で定義します
const styles = { 
  page: { pb: 15 },
  container: { pt: { xs: 2, sm: 3, md: 10 }, pb: { xs: 1, sm: 3, md: 10 }, height: "100%", width: { xs: "90%", sm: "80%", md: "80%" } }
};

const ErrorScreen = ({ earthquake, open, onOpen, onClose, onRestart }) => (
  <BoxCenterStart sx={styles.page}>
    <CommonCard>
      <TypographyBold>再度報告業務を開始してください</TypographyBold>
      <p>「報告業務開始ボタン」をクリックして報告業務を開始してください。</p>
      <button onClick={onOpen}>報告業務開始</button>
    </CommonCard>
    <BaseDialog
      open={open}
      onClose={onClose}
      title="確認"
      message={earthquake ? "地震一覧に遷移します。\nよろしいですか？" : "報告業務を開始します。"}
      onConfirm={onRestart}
      confirmText="OK"
      cancelText="キャンセル"
    />
  </BoxCenterStart>
);

export default ErrorScreen;